export default {
	"common": {
		"edit": "chỉnh sửa",
		"welcome_message": "Chào mừng đến với ELSA dành cho Tổ chức",
		"slogan": "Nói tiếng Anh tự tin, trôi chảy và dễ dàng với ELSA",
		"invited_by": "Được mời bởi",
		"agree_to": "Tôi đồng ý với",
		"terms_and_conditions": "Điều khoản và điều kiện của ELSA",
		"search": "Tìm kiếm",
		"email": "Email",
		"cancel": "Hủy bỏ",
		"save": "Lưu lại",
		"or": "Hoặc",
		"account_confirmed": "Tài khoản của bạn đã được xác nhận.",
		"no_values": "Không tìm thấy",
		"terms_and_privacy_policy": "Điều khoản và chính sách bảo mật",
		"continue": "Tiếp tục",
		"invite": "Mời",
		"generic_error_message": "Đã xảy ra lỗi. Thử lại sau.",
		"error_duplidate_group_name": "Tên lớp bị trùng trong tệp",
		"login": "Đăng nhập",
		"and": "&",
		"terms_of_use": "Điều khoản sử dụng",
		"privacy_policy": "Chính sách bảo mật",
		"name": "Tên",
		"view_list": "Xem thêm",
		"total": "Tổng",
		"lessons": "Bài học",
		"hours": "Giờ",
		"average": "Trung bình",
		"lessons_per_day": "Bài học mỗi ngày",
		"minutes_per_day": "Phút mỗi ngày",
		"pending_invites": "Lời mời đang chờ xử lý",
		"invite_success": "Lời mời đã được chấp nhận",
		"invite_not_success": "Lời mời không được chấp nhận",
		"invite_send_not_success": "Không thể gửi lời mời",
		"no_invite_seleted": "Không có lời mời nào được chọn",
		"select_all": "Chọn tất cả",
		"minutes": "Phút",
		"warnings": {
			"no_report_data": "Không tìm thấy báo cáo, vui lòng thử lại",
			"session_expired": "Phiên đăng nhập hết hạn, vui lòng đăng nhập lại"
		},
		"resend_invite": "Gửi lại lời mời",
		"remove_invite": "Xóa lời mời đang chờ xử lý",
		"export_report": "Xuất báo cáo",
		"export_assessment": "Điểm đánh giá",
		"lesson_detail": "Lịch sử bài học",
		"file_type_not_allowed": "Loại tệp không phù hợp",
		"import": "Nhập",
		"assessment-history": "Lịch sử đánh giá"
	},
	"date_interval_picker": {
		"start_end_date": "Ngày bắt đầu & ngày kết thúc",
		"save": "Lưu",
		"cancel": "Hủy bỏ",
		"this_month": "Tháng này",
		"apply": "Áp dụng"
	},
	"date_picker": {
		"start_date": "Ngày bắt đầu",
		"end_date": "Ngày kết thúc",
		"to": "Tới",
		"last_week": "Tuần trước",
		"last_month": "Tháng trước",
		"last_three_months": "3 tháng trước",
		"last_six_months": "6 tháng trước",
		"last_year": "1 năm trước",
		"daily": "Hằng ngày",
		"weekly": "Hằng tuần",
		"monthly": "Hằng tháng"
	},
	"company_labels": {
		"average_lessons": "Số ngày học mỗi tuần",
		"all_users": "Tất cả người dùng",
		"groups": "Nhóm",
		"teachers": "Trưởng nhóm",
		"remove_teacher_from_organization": "Gỡ bỏ trưởng nhóm khỏi tổ chức",
		"remove_student_from_organization": "Gỡ bỏ nhân viên khỏi tổ chức",
		"remove_student_from_group": "Xóa học sinh khỏi nhóm",
		"active_students": "Nhân viên có hoạt động",
		"teacher": "Trưởng nhóm",
		"students": "Nhân viên",
		"student": "Nhân viên",
		"all_groups": "Tất cả nhóm",
		"edit_group": "Chỉnh sửa nhóm",
		"add_to_group_title": "Thêm vào nhóm",
		"add_to_group": "Nhóm mới",
		"import_class_success_title": "{numberClassesImported} Nhóm vừa được tạo thành công",
		"add_to_group_success": "Người dùng đã được thêm vào nhóm",
		"add_to_group_warning": "Người dùng không thể được thêm vào nhóm",
		"assign_license_to_user_success": "Chuyển nhượng giấy phép thành công cho người dùng",
		"assign_license_to_user_warning": "Chuyển nhượng giấy phép cho người dùng không thành công",
		"remove_from_class_success": "Người dùng đã được gỡ bỏ khỏi nhóm",
		"remove_from_class_warning": "Người dùng không thể gỡ bỏ khỏi nhóm",
		"create_new_group": "Tạo nhóm mới",
		"no_groups_yet": "Bạn chưa có nhóm nào.",
		"no_students_yet": "Bạn chưa có nhân viên nào.",
		"create_group": "Tạo nhóm",
		"import_groups": "Nhập nhóm",
		"import_groups_success": "Các nhóm đã được tạo thành công",
		"import_users_to_groups_success": "Nhập các nhân viên vào nhóm thành công",
		"group_title": "Tên nhóm",
		"group_name": "Tên nhóm",
		"group_details": "Thông tin chi tiết",
		"step_group_details": "{step}. Thông tin chi tiết",
		"no_teachers_available": "Không có trưởng nhóm tiềm năng",
		"all_teachers": "Tất cả trưởng nhóm",
		"all_students": "Tất cả nhân viên",
		"upload_emails": "Nhập nhân viên vào nhóm",
		"errors": {
			"please_provide_group_name": "Vui lòng cung cấp tên nhóm",
			"please_provide_teacher_name": "Vui lòng cung cấp tên trưởng nhóm"
		},
		"add_students": "Thêm nhân viên",
		"group_overview": "Tổng quan về nhóm",
		"group_teacher": "Trưởng nhóm",
		"will_be_added_students": "{numberOfUsers} Nhân viên sẽ được thêm vào lớp ngay khi bạn tạo lớp.",
		"student_consent_to_class": "{numberOfUsers} Nhân viên sẽ được đăng ký tự động trong nhóm.",
		"students_list": "Danh sách nhân viên",
		"your_group_was_created": "Nhóm của bạn đã được thiết lập,",
		"error_when_inviting": "Đã xảy ra lỗi khi mời nhân viên. Thử lại sau.",
		"invited_users": "và {students} đã được gửi lời mời!",
		"goals": {
			"engage_students": "Tham gia với nhân viên của bạn",
			"engage_review": "Bạn có thể yêu cầu nhân viên bắt đầu thực hành tiếng Anh. Đây là những gì chúng tôi đề xuất, hãy bắt đầu với:",
			"get_insight_about_students": "hiểu rõ hơn về về kỹ năng phát âm hiện tại của nhân viên"
		},
		"invite_students": "Mời nhân viên",
		"student_name": "Tên nhân viên",
		"teachers_page": {
			"title": "Trưởng nhóm",
			"invite": "Mời trưởng nhóm",
			"table": {
				"number_of_students": "Số nhân viên",
				"number_of_classes": "Số nhóm"
			}
		},
		"students_page": {
			"title": "Nhân viên",
			"invite": "Mời nhân viên"
		},
		"select_teacher": "Lựa chọn trưởng nhóm",
		"add_new_teacher": "Thêm trưởng nhóm mới",
		"dashboard": {
			"class_overview": "Tổng quan về nhóm",
			"view_class": "Xem nhóm",
			"profile": "Hồ sơ công ty",
			"add_student": "Mời nhân viên",
			"new_group": "Tạo nhóm mới",
			"add_teacher": "Mời trưởng nhóm"
		},
		"teacher_info": {
			"show_list_of_classes": "Hiển thị danh sách nhóm",
			"show_list_of_students": "Hiển thị danh sách nhân viên",
			"classes_assigned_to": "Nhóm được phân công",
			"show_all_classes": "Hiển thị tất cả nhóm"
		},
		"classes": {
			"active_students": "Nhân viên có hoạt động (Học ít nhất 1 bài)",
			"import_users": "Nhập nhân viên vào nhiều đội "
		},
		"students_improvement": "Cải thiện đội ngũ",
		"auto_enroll_message_confirm": "Nhân viên được đăng ký tự động trong nhóm. <br/> Bằng cách chọn tùy chọn đăng ký tự động, bạn phải có sự cho phép trước của người dùng để thêm họ vào lớp / nhóm này. <br/> Bạn có muốn tiếp tục?",
		"accept_invitation_enroll_message_confirm": "Người dùng phải chấp nhận lời mời để đăng ký vào nhóm. Bạn có muốn tiếp tục không?",
		"pending_invites_teacher": "Lời mời trưởng nhóm đang chờ xử lý."
	},
	"school_labels": {
		"average_lessons": "Số ngày học mỗi tuần",
		"all_users": "Tất cả học viên",
		"groups": "Lớp học",
		"teachers": "Giáo viên",
		"teacher": "Giáo viên",
		"students": "Học viên",
		"student": "Học viên",
		"active_students": "học viên có hoạt động",
		"remove_teacher_from_organization": "Gõ bỏ trưởng nhóm khỏi tổ chức",
		"remove_student_from_organization": "Gỡ bỏ học viên khỏi tổ chức",
		"remove_student_from_group": "Xóa học sinh khỏi lớp học",
		"all_teachers": "Tất cả giáo viên",
		"all_students": "Tất cả học viên",
		"all_groups": "Tất cả lớp học",
		"edit_group": "Chỉnh sửa lớp học",
		"add_to_group_title": "Thêm lớp học",
		"add_to_group": "Lớp học mới",
		"import_class_success_title": "{numberClassesImported} Lớp học đã được thiết lập thành công",
		"add_to_group_success": "Người dùng đã được thêm vào lớp học",
		"add_to_group_warning": "Người dùng không thể được thêm vào lớp học",
		"remove_from_class_success": "Người dùng đã được gỡ bỏ khỏi nhóm",
		"remove_from_class_warning": "Người dùng không thể gỡ bỏ khỏi nhóm",
		"create_new_group": "Tạo lớp học mới",
		"no_groups_yet": "Bạn không có lớp học nào.",
		"no_students_yet": "Bạn chưa có học viên nào.",
		"no_teachers_available": "Không có giáo viên",
		"create_group": "Tạo lớp học",
		"import_groups": "Tạo nhiều lớp",
		"import_groups_success": "Lớp học đã được tạo",
		"import_users_to_groups_success": "Nhập học viên vào lớp học thành công.",
		"group_title": "Tên lớp học",
		"group_name": "Tên lớp học",
		"group_details": "Thông tin chi tiết lớp học",
		"step_group_details": "{step}. Thông tin chi tiết lớp học",
		"select_teacher": "Lựa chọn giáo viên",
		"add_new_teacher": "Thêm giáo viên mới",
		"upload_emails": "Nhập học viên và lớp học",
		"errors": {
			"please_provide_group_name": "Vui lòng cung cấp tên lớp học",
			"please_provide_teacher_name": "Vui lòng cung cấp tên giáo viên "
		},
		"add_students": "Thêm học viên",
		"group_overview": "Tổng quan lớp học",
		"group_teacher": "Giáo viên lớp học",
		"will_be_added_students": "{numberOfUsers} Học viên sẽ được thêm vào lớp ngay khi bạn tạo nó.",
		"student_consent_to_class": "{numberOfUsers} Học viên sẽ được đăng ký tự động trong lớp.",
		"students_list": "Danh sách học viên",
		"your_group_was_created": "Lớp học của bạn đã được tạo,",
		"error_when_inviting": "nhưng đã xảy ra lỗi khi mời học viên. Thử lại sau.",
		"invited_users": "{students} Học viên đã được gửi lời mời!",
		"goals": {
			"engage_students": "Tham gia với học viên của bạn",
			"engage_review": "Bạn có thể yêu cầu học viên của bạn bắt đầu thực hành tiếng Anh. Đây là những gì chúng tôi đề nghị, bắt đầu với:",
			"get_insight_about_students": "Nhận thông tin chi tiết về các kỹ năng phát âm hiện tại của học viên"
		},
		"invite_students": "Mời học viên",
		"student_name": "Tên học viên",
		"teachers_page": {
			"title": "Giáo viên",
			"invite": "Mời giáo viên",
			"table": {
				"number_of_students": "Số học viên",
				"number_of_classes": "Số lớp học"
			}
		},
		"students_page": {
			"title": "Học viên",
			"invite": "Mời học viên"
		},
		"dashboard": {
			"class_overview": "Tổng quan lớp",
			"view_class": "Xem lớp học",
			"profile": "Hồ sơ của trường",
			"add_student": "Mời học viên",
			"new_group": "Tạo lớp học mới",
			"add_teacher": "Mời giáo viên"
		},
		"teacher_info": {
			"show_list_of_classes": "Hiển thị danh sách lớp học",
			"show_list_of_students": "Hiển thị danh sách học viên",
			"classes_assigned_to": "Lớp học được giao",
			"show_all_classes": "Hiển thị tất cả lớp học"
		},
		"classes": {
			"active_students": "học viên có hoạt động (Học ít nhất 1 bài)",
			"import_users": "Nhập học viên vào nhiều lớp"
		},
		"students_improvement": "Mức độ tiến bộ của lớp",
		"auto_enroll_message_confirm": "Học viên sẽ được đăng ký tự động trong lớp.. <br/>Bằng cách chọn tùy chọn đăng ký tự động, bạn phải có sự cho phép trước của học viên để thêm họ vào lớp này. < . <br/><br/>Bạn có muốn tiếp tục?",
		"accept_invitation_enroll_message_confirm": "Người dùng phải chấp nhận lời mời để đăng ký vào lớp. <br/>Bạn có muốn tiếp tục không?",
		"delete_user_from_class_message_confirm":"Bạn có muốn xóa học sinh không?",
		"pending_invites_teacher": "Lời mời giáo viên đang chờ xử lý"
	},
	"elsa_goals": {
		"goals": "Sử dụng ứng dụng phát âm hàng đầu Thế giới để giúp học viên của bạn cải thiện kỹ năng tiếng Anh:",
		"goal1": "Lịch học linh hoạt",
		"goal2": "Theo dõi báo cáo tiến độ",
		"goal3": "Mời từng học viên hoặc theo nhóm "
	},
	"navbar": {
		"dashboard": "Bảng điều khiển",
		"classes": "Lớp học",
		"teachers": "Giáo viên",
		"students": "Học viên",
		"account": "Tài khoản",
		"my_profile": "Hồ sơ của tôi",
		"manage": "Danh sách tổ chức",
		"logout": "Đăng xuất",
		"hello": "Xin chào",
		"organizations": "Tổ chức",
		"org_current": "Tổ chức hiện tại",
		"Language": "Ngôn ngữ"
	},
	"teacher_info": {
		"profile": "Hồ sơ",
		"first_name": "Tên",
		"last_name": "Họ",
		"email": "Email",
		"username": "Tên tài khoản",
		"phone_number": "Số điện thoại",
		"user_roles": "Vai trò người dùng",
		"department": "Phòng ban",
		"title": "Chức danh",
		"user_role": "Vai trò",
		"overview": "Tổng quan"
	},
	"student_info": {
		"overview": "Tổng quan",
		"profile": "Hồ sơ"
	},
	"user_profile": {
		"title": "",
		"dont_belong_organization": "Bạn không thuộc về bất kỳ tổ chức nào.",
		"join_organization": "Tham gia tổ chức",
		"create_organization": "Thiết lập tổ chức",
		"withdraw_from_organization": "Rút khỏi tổ chức",
		"your_profile": {
			"title": "Hồ sơ của bạn",
			"first_name": "Tên",
			"last_name": "Họ",
			"user_name": "Tên tài khoản",
			"email": "Email",
			"not_verified": "Chưa xác minh",
			"phone_number": "Số điện thoại",
			"did_not_receive": "Không nhận được email xác nhận?",
			"resent_email": "Gửi lại email",
			"modals": {
				"edit_profile": {
					"update_success": "Thông tin người dùng đã được cập nhật thành công.",
					"title": "Chỉnh sửa hồ sơ",
					"upload_image": {
						"label": "Tải hình ảnh lên"
					},
					"first_name": {
						"label": "Tên",
						"placeholder": "Nhập tên của bạn"
					},
					"last_name": {
						"label": "Họ",
						"placeholder": "Nhập họ của bạn"
					},
					"email": {
						"label": "Email",
						"placeholder": "Nhập địa chỉ email của bạn"
					},
					"user_name": {
						"label": "Tên tài khoản",
						"placeholder": "Nhập tên tài khoản"
					},
					"phone": {
						"label": "Số điện thoại",
						"placeholder": "+1-000-000-0000"
					},
					"save": "lưu",
					"cancel": "hủy bỏ"
				},
				"confirm_new_email": {
					"title": "Xác nhận địa chỉ email mới của bạn",
					"message": "Chúng tôi đã gửi cho bạn một email xác nhận. Kiểm tra hộp thư đến và xác minh địa chỉ email mới của bạn.",
					"button_label": "Đã rõ!"
				}
			}
		},
		"change_password": {
			"title": "Thay đổi mật khẩu",
			"password": "Mật khẩu",
			"modals": {
				"title": "Thay đổi mật khẩu",
				"current_password": {
					"label": "Mật khẩu hiện tại",
					"placeholder": "Nhập mật khẩu"
				},
				"new_password": {
					"label": "Mật khẩu mới",
					"placeholder": "Nhập mật khẩu mới"
				},
				"confirm_new_password": {
					"label": "Nhập lại mật khẩu mới",
					"placeholder": "Nhập lại mật khẩu mới"
				},
				"save": "Lưu",
				"cancel": "hủy bỏ",
				"change_pass_elsa": "Vui lòng sử dụng ứng dụng ELSA để thay đổi mật khẩu của bạn."
			}
		},
		"your_organizations": {
			"title": "Các tổ chức của bạn",
			"modals": {
				"title": "Rút khỏi {name}",
				"admin": {
					"message_1": "Bạn có chắc chắn muốn rút khỏi {name}?",
					"message_2": "Bạn là quản trị viên duy nhất của {name}. Để rút khỏi tổ chức, hãy mời người khác làm chủ tài khoản."
				},
				"teacher": {
					"message_1": "Bạn có chắc chắn muốn rút khỏi {name}? Bạn sẽ mất quyền truy cập đối với Pro license hiện tại của bạn.",
					"message_2": "Bạn là giáo viên được chỉ định cho {numberOfClasses} lớp. Để rút khỏi tổ chức, hãy liên hệ với quản trị viên để gỡ tài khoản của bạn khỏi vai trò đó."
				},
				"student": {
					"message_1": "Nếu bạn rút khỏi, bạn sẽ cần một lời mời mới để tham gia {name} lần nữa.",
					"message_2": "Bạn có chắc chắn muốn rút khỏi {name}? Bạn sẽ mất quyền truy cập vào Pro license hiện tại của bạn."
				},
				"confirm": "Đúng, tôi chắc",
				"cancel": "Không, hủy bỏ",
				"got_it": "Đã rõ!"
			}
		},
		"social": {
			"title": "Xã hội",
			"modals": {
				"title": "Nhập mật khẩu",
				"subtitle": "Nhập mật khẩu để bạn vẫn có thể truy cập tài khoản ELSA của mình mà không cần Facebook",
				"password": {
					"label": "Mật khẩu mới",
					"placeholder": "Nhập mật khẩu mới"
				},
				"repeat_password": {
					"label": "Nhập lại mật khẩu mới",
					"placeholder": "Nhập lại mật khẩu mới"
				},
				"save": "lưu",
				"cancel": "hủy bỏ"
			}
		},
		"delete_account": {
			"button": "Xóa tài khoản",
			"modals": {
				"title": "Xóa tài khoản",
				"warning": "Bạn có chắc chắn muốn rút khỏi {organizationName}? Nếu vậy, hãy điền vào phần sau:",
				"terms_and_conditions": "Tôi hiểu rằng tôi sẽ mất quyền truy cập vào dữ liệu lịch sử và License hiện tại của mình.",
				"password": "Mật khẩu",
				"delete_account": "xóa tài khoản",
				"cancel": "hủy bỏ"
			}
		}
	},
	"login": {
		"title": "Đăng nhập bằng tài khoản ELSA của bạn",
		"accept_invitation": "Đăng nhập vào tài khoản ELSA của bạn để chấp nhận lời mời từ {organizationName}.",
		"email_field": {
			"label": "email",
			"placeholder": "Nhập địa chỉ email"
		},
		"password_field": {
			"label": "mật khẩu",
			"placeholder": "Nhập mật khẩu"
		},
		"forgot_password": "Quên mật khẩu?",
		"login_and_accept_invitation": "Đăng nhập và chấp nhận lời mời",
		"dont_have_account": "Bạn không có tài khoản?",
		"create_account": "Tạo tài khoản",
		"login": "Đăng Nhập",
		"invalid_token": "Lời mời đã hết hạn hoặc không hợp lệ"
	},
	"confirm_account": {
		"title": "Xác nhận tài khoản của bạn",
		"check_inbox": "Chúng tôi đã gửi cho bạn một email xác nhận. Kiểm tra hộp thư đến của bạn và xác minh tài khoản của bạn.",
		"didnt_receive": "Không nhận được email?",
		"resend_confirmation": "Gửi lại email xác nhận",
		"got_it": "Đã rõ!"
	},
	"resend_confirmation": {
		"title": "Gửi lại email xác nhận",
		"send_confirmation": "Chúng tôi sẽ gửi cho bạn một email xác nhận mới. Vui lòng xác minh rằng địa chỉ email của bạn là chính xác.",
		"email_field": {
			"label": "email",
			"placeholder": "Nhập email"
		},
		"resend_email": "Gửi lại email"
	},
	"recover_password": {
		"title": "Khôi phục mật khẩu",
		"enter_email_to_reset": "Nhập địa chỉ email của bạn để chúng tôi có thể đặt lại mật khẩu",
		"reset_pass_elsa": "Vui lòng sử dụng ứng dụng ELSA để đặt lại mật khẩu của bạn.",
		"email_field": {
			"label": "địa chỉ email",
			"placeholder": "Nhập địa chỉ email"
		},
		"reset_password": "Đặt lại mật khẩu",
		"sent_email_check_inbox": "Chúng tôi đã gửi cho bạn một email. Kiểm tra hộp thư đến của bạn và đặt lại mật khẩu.",
		"got_it": "Đã rõ!"
	},
	"reset_password_modal": {
		"title": "Đặt lại mật khẩu",
		"enter_your_password": "Nhập mật khẩu mới",
		"button_text": "Đặt lại mật khẩu",
		"new_password_field": {
			"label": "Mật khẩu mới",
			"placeholder": "Nhập mật khẩu mới"
		},
		"confirm_password_field": {
			"label": "Xác nhận mật khẩu mới",
			"placeholder": "Nhập lại mật khẩu mới "
		}
	},
	"sign_up": {
		"title": "Tạo tài khoản ElSA",
		"sign_up": "Đăng ký",
		"first_name_field": {
			"label": "Tên",
			"placeholder": "Nhập tên"
		},
		"last_name_field": {
			"label": "Họ",
			"placeholder": "Nhập họ"
		},
		"email_field": {
			"label": "Địa chỉ email",
			"placeholder": "Nhập địa chỉ email"
		},
		"password_field": {
			"label": "Mật khẩu",
			"placeholder": "Nhập mật khẩu"
		},
		"signup_accept_invitation": "Đăng ký và chấp nhận lời mời",
		"invitation_code": "Bạn có mã lời mời không?",
		"tooltip_message": "Nếu bạn có mã lời mời, hãy nhập mã vào đây.",
        "by_signing_up_to_elsa": "Bằng cách đăng ký ELSA, bạn đồng ý với",
        "to_our": "của chúng tôi.",
		"already_have_an_account": "Bạn đã có tài khoản?"
	},
	"verify_facebook_info_modal": {
		"title": "Xác minh thông tin của bạn",
		"save_continue": "Lưu lại và tiếp tục",
		"first_name_field": {
			"label": "Tên",
			"placeholder": "Tên"
		},
		"last_name_field": {
			"label": "Họ",
			"placeholder": "Họ"
		},
		"email_field": {
			"label": "Địa chỉ email",
			"placeholder": "Nhập địa chỉ email"
		}
	},
	"organizations": {
		"groups": "Nhóm",
		"users": "Người dùng",
		"table": {
			"user_email": "Địa chỉ email",
			"username": "Tên",
			"titleDept": "chức danh / phòng.",
			"roles": "Vai trò",
			"actions": "Hoạt động",
			"empty": "Không tìm thấy người dùng",
			"empty_admin": "Không tìm thấy quản trị viên",
			"empty_student": "Không tìm thấy học viên",
			"empty_teacher": "Không tìm thấy giáo viên "
		},
		"users_section": {
			"invite_users": "Mời người dùng",
			"invite_by_email": "Mời qua email",
			"import_users": "Nhập người dùng vào nhiều nhóm",
			"import_elsa_id": "Nhập Elsa_ID vào nhiều nhóm",
			"share_code": "Nhận mã",
			"share_link": "Chia sẻ link",
			"share_qr_code": "Chia sẻ mã QR",
			"add_to_group": "Thêm vào nhóm",
			"add_to_class": "Thêm vào lớp",
			"revoke_license": "Thu hồi license",
			"enable_license": "Kích hoạt license",
			"disable": "Vô hiệu hóa",
			"delete": "Xóa",
			"no_users": "Mời người dùng tham gia công ty của bạn:",
			"no_users_1": "Bạn chưa có người dùng nào.",
			"no_users_2": "thêm người dùng hoặc chia sẻ tổ chức của bạn với họ.",
			"select_role": "Lựa chọn vai trò",
			"user_profile": {
				"user_details": {
					"title": "Thông tin chi tiết người dùng"
				},
				"user_roles": {
					"title": "Vai trò người dùng"
				}
			},
			"enable_license_message": "Pro License phát hành cho {firstName} {lastName}",
			"modals": {
				"share_qr_code": {
					"title": "chia sẻ mã QR",
					"print_code": "In mã QR sau đây",
					"share_with_users": "Chia sẻ nó với người dùng để họ có thể quét và tham gia tổ chức của bạn.",
					"print": "In",
					"no_cancel": "Hủy bỏ"
				},
				"share_link": {
					"title": "chia sẻ link",
					"copy_link": "Sao chép đường dẫn",
					"got_it": "Sao chép thành công!",
					"cancel": "Hủy bỏ"
				},
				"share_code": {
					"title": "Nhận mã",
					"share_the_following_code": "Tạo mã",
					"user_can_join": "Chia sẻ mã với người dùng để họ có thể sử dụng nó để tham gia tổ chức của bạn.",
					"generate_code": "Tạo mã",
					"done": "Hoàn thành"
				},
				"invite_users": {
					"copy_and_paste": "Sao chép và dán địa chỉ email",
					"title": "Gửi email mời",
					"select_role_placeholder": "Chọn vai trò người dùng",
					"select_role_label": "Vai trò người dùng",
					"copy_paste_emails": "Sao chép và dán địa chỉ email",
					"invite_users": "Mời người dùng",
					"add_email": "Chèn nhiều địa chỉ email (cách nhau bằng dấu phẩy)",
					"success": "Người dùng đã được thêm vào danh sách người dùng",
					"consent": "Chấp thuận",
					"consent1": "Tự động đăng ký người dùng vào {organizationName}"
				},
				"edit_user": {
					"update_success": "Cập nhật thành công",
					"title": "Chỉnh sửa vai trò người dùng",
					"user_title": "Chọn chức danh",
					"user_title_placeholder": "Chức danh",
					"department": "Chọn phòng ban",
					"department_placeholder": "Phòng ban"
				},
				"disable": {
					"title": "Vô hiệu hóa {numberOfAccounts} tài khoản người dùng",
					"message": "Bạn có chắc chắn muốn thu hồi Pro License cho {numberOfAccounts} người dùng?",
					"confirm": "Đúng, thu hồi",
					"cancel": "Không, hủy bỏ"
				},
				"delete": {
					"title": "Gỡ bỏ người dùng khỏi tổ chức",
					"message": "Bạn có chắc chắn muốn gỡ bỏ {numberOfAccounts} người dùng từ tổ chức của bạn không?",
					"confirm": "Đúng, gỡ bỏ",
					"cancel": "Không, hủy bỏ"
				},
				"delete_from_class": {
					"title": "Gỡ bỏ người dùng khỏi nhóm",
					"message":
					"Bạn có chắc chắn muốn gỡ bỏ {numberOfAccounts} người dùng từ nhóm của bạn không?",
					"confirm": "Đúng, gỡ bỏ",
					"cancel": "Không, hủy bỏ"
				},
			},
			"popovers": {
				"groups": {
					"title": "Thêm vào nhóm",
					"add_group": "Thêm nhóm",
					"manage_groups": "Quản lý nhóm"
				},
				"classes": {
					"title": "Thêm vào lớp học",
					"new_class": "Lớp học mới"
				},
				"roles": {
					"title": "Chỉnh sửa vai trò"
				}
			}
		},
		"invite_users": {
			"title": "Mời người dùng",
			"subtitle": "Mời người dùng tham gia công ty của bạn:",
			"import_users": "Nhập danh sách địa chỉ email vào nhóm đã chọn",
			"import_users_classes": "Nhập danh sách địa chỉ email cho nhiều nhóm",
			"share_link": "Chia sẻ link",
			"mail_invite": "Sao chép và dán địa chỉ email",
			"multiple_mail_invite_with_enrolled": "{numberOfInvites} Người dùng đã được đăng ký vào nhóm",
			"multiple_mail_invite": "{numberOfInvites} Người dùng đã được mời",
			"multiple_mail_to_invite": "{numberOfInvites} Người dùng sẽ được mời",
			"import": {
				"elsa-title": "danh sách nhập ID người dùng ELSA",
				"title": "Danh sách nhập địa chỉ email",
				"subtitle": "Danh sách nhập",
				"instructions": "Kéo và thả tập tin của bạn vào đây để tải chúng lên.",
				"files": "{fileCount} Tập tin đã được tải lên",
				"instructions2": "Tải xuống mẫu trong",
				"instructions3": "Điền theo mẫu và kéo thả tập tin lên",
				"get_template": "Lấy mẫu",
				"get_template_xlsx": "Định dạng MS Excel",
				"get_template_csv": "Định dạng CSV",
				"browse_files": "Duyệt tập tin"
			},
			"link": {

			},
			"mail": {
				"title": "Sao chép và dán địa chỉ email "
			},
			"confirmation_title": "Xác nhận",
			"warning_message_delay_invite": "Lưu ý: Quá trình mời có thể mất vài phút để hoàn tất. Vui lòng quay lại sau để xem danh sách Người học đã được cập nhật."
		}
	},
	"table_row": {
		"actions": {
			"remove_from_group": "Gỡ khỏi nhóm",
			"add_to_class": "Thêm vào lớp",
			"disable": "Vô hiệu hóa",
			"delete": "Xóa"
		}
	},
	"organization_profile": {
		"title": "Hồ sơ",
		"admins": "Quản trị viên",
		"invite_another_admin": "Mời quản trị viên khác",
		"pending_request": "Yêu cầu đang chờ xử lý",
		"organization_name": "Tên Tổ chức",
		"organization_username": "Tên tài khoản của tổ chức",
		"organization_type_industry": "Loại / Ngành của tổ chức",
		"phone": "Số điện thoại",
		"address": "Địa chỉ",
		"affiliate": "Affiliate",
		"admin_actions": {
			"remove_from_admin": "Gỡ bỏ",
			"edit_user": "Chỉnh sửa người dùng",
			"remove_from_organization": "Gỡ bỏ khỏi tổ chức",
			"user_id_only_admin": "Không thể gỡ bỏ quản trị viên duy nhất của tổ chức."
		},
		"remove_admin_modal": {
			"title": "Gỡ bỏ Quản trị viên",
			"yes_remove": "Đúng, gỡ bỏ",
			"no_cancel": "Không, huỷ bỏ"
		},
		"invite_admin_modal": {
			"invite_success": "lời mời đã được gửi.",
			"remove_invite_success": "Đã gỡ lời mời thành công",
			"remove_invite_fail": "Đã gỡ lời mời thành công",
			"confirm_remove_invitation": "Bạn có muốn gỡ lời mời này không?",
			"title": "Mời Quản trị viên mới",
			"email_field": {
				"label": "Địa chỉ Email",
				"placeholder": "Nhập địa chỉ email"
			},
			"invite_button": "Mời",
			"cancel_button": "Huỷ bỏ"
		},
		"delete_disable_organization_modal": {
			"title_delete": "Xoá",
			"title_disable": "Vô hiệu hoá",
			"title_enable": "Mở lại",
			"password_field": {
				"label": "mật khẩu",
				"placeholder": "Nhập mật khẩu"
			},
			"delete_button": "Xoá tổ chức",
			"disable_button": "Đúng, vô hiệu hoá",
			"enable_button": "Đúng, mở lại",
			"cancel_button": "Huỷ bỏ",
			"delete_terms": "Tôi hiểu rằng tôi sẽ mất quyền truy cập vào dữ liệu lịch sử và Licenses hiện tại của mình.",
			"disable_terms": "Tôi hiểu rằng người dùng sẽ mất Licenses trả tiền của họ.",
			"are_you_sure_disable": "Bạn có chắc muốn vô hiệu hoá",
			"are_you_sure_enable": "Bạn có chắc muốn mở lại",
			"are_you_sure_widthraw": "Bạn có chắc muốn rút lại",
			"if_so_fill_following": "Nếu vậy, vui lòng cung cấp các thông tin sau:"
		},
		"edit_organization_modal": {
			"invite_not_send": "Tổ chức đã được tạo, nhưng không thể gửi lời mời.",
			"update_success": "Tổ chức đã được cập nhật",
			"create_success": "Tổ chức đã được tạo",
			"create_title": "Tạo tổ chức mới",
			"edit_title": "Chỉnh sửa tổ chức",
			"save": "Lưu",
			"cancel": "Huỷ bỏ",
			"upload_logo_field": {
				"label": "Tải logo"
			},
			"verified_organization": "Xác minh tổ chức",
			"enable_organization": "Mở lại tổ chức",
			"disable_organization": "Vô hiệu hoá tổ chức",
			"delete_organization": "Xoá tổ chức",
			"are_you_sure_disable": "Bạn có chắc muốn vô hiệu hoá",
			"name_field": {
				"label": "Tên Tổ chức",
				"placeholder": "Nhập tên tổ chức"
			},
			"username_field": {
				"label": "Tên đăng nhập",
				"placeholder": "Nhập tên đăng nhập của tổ chức"
			},
			"org_type_field": {
				"label": "Loại tổ chức",
				"placeholder": "Chọn loại tổ chức"
			},
			"industry_field": {
				"label": "Ngành",
				"placeholder": "Chọn ngành"
			},
			"address_field": {
				"label": "Địa chỉ",
				"placeholder": "Nhập địa chỉ của tổ chức"
			},
			"phone_field": {
				"label": "Điện thoại",
				"placeholder": "+1-000-000-0000"
			},
			"country_field": {
				"label": "Quốc gia",
				"placeholder": "Nhập quốc gia"
			},
			"state_field": {
				"label": "Bang/huyện",
				"placeholder": "Nhập bang/huyện"
			},
			"city_field": {
				"label": "Thành phố",
				"placeholder": "Nhập thành phố"
			},
			"post_code_field": {
				"label": "Mã bưu điện",
				"placeholder": "Mã bưu điện"
			},
			"owner_field": {
				"label": "Chủ tài khoản",
				"placeholder": "Chủ tài khoản"
			},
			"affiliate_field": {
				"label": "Affiliate",
				"placeholder": "Không có"
			},
			"timezone_field": {
				"label": "Múi giờ",
				"placeholder": "Etc/GMT"
			}
		}
	},
	"admin": {
		"organizations": {
			"title": "Tổ chức",
			"create_new_organization": "Tạo tổ chức mới",
			"import_organizations": "Nhập tệp các tổ chức",
			"verify": "Xác minh",
			"table": {
				"verification": "Sự xác minh",
				"not_verified": "Chưa xác minh",
				"verified": "Đã xác minh",
				"organization_name": "Tên tổ chức",
				"status": "Tình trạng",
				"licences": "Licenses",
				"empty": "Không tìm thấy tổ chức",
				"active": "đang hoạt động",
				"inactive": "Bị vô hiệu",
				"affiliate": "Affiliate",
				"created_at": "Ngày tạo"
			},
			"filter_menu": {
				"all": "Tất cả",
				"active": "Đang hoạt động",
				"disabled": "Bị vô hiệu",
				"verified": "Đã xác minh"
			}
		}
	},
	"organization_page": {
		"organizations": "Tổ chức",
		"disable": "Vô hiệu hoá",
		"delete": "Xoá",
		"menu": {
			"licences": "Licenses",
			"users": {
				"title": "Người dùng",
				"all_users": "Tất cả người dùng",
				"employees": "Nhân viên",
				"leads": "Trưởng nhóm",
				"admins": "Quản trị viên"
			},
			"groups": "Nhóm",
			"profile": "Hồ sơ"
		}
	},
	"disable_organization_modal": {
		"title": "Vô hiệu hoá",
		"yes_disable": "Đúng, vô hiệu hoá",
		"no_cancel": "Không, huỷ bỏ"
	},
	"onboarding": {
		"welcome": "Chào mừng bạn đến với ELSA",
		"welcome_subtitle": "Hãy cho chúng tôi biết thêm về bạn để chúng tôi có thể hướng dẫn bạn trên hành trình cùng ELSA",
		"who_are_you": "Bạn là?",
		"select_option": "Chọn một trong các lựa chọn dưới đây",
		"school": "Trường học",
		"school_admin": "Quản trị viên của trường học",
		"company": "Công ty",
		"company_admin": "Quản trị viên của công ty",
		"teacher": "Giáo viên",
		"student": "Học viên",
		"continue": "Tiếp tục"
	},
	"school": {
		"setup_school": {
			"successfully_created": "Trường của bạn đã được tạo thành công.",
			"setup_your_school": "Cài đặt trường học của bạn",
			"invite_students_teachers": "Mời học sinh và giáo viên tham gia tổ chức của bạn.",
			"create_your_first_class": "Hãy tạo lớp học đầu tiên!",
			"create_class": "Tạo lớp",
			"invite_teachers": "Mời giáo viên",
			"invite_students": "Mời học sinh",
			"teacher": "Giáo viên",
			"continue": "Tiếp tục"
		},
		"create_edit_modal": {
			"title": "Tạo trường",
			"create": "Tạo",
			"cancel": "Huỷ bỏ",
			"name_field": {
				"label": "Tên trường",
				"placeholder": "Nhập tên trường"
			},
			"username_fields": {
				"label": "Tên người dùng",
				"placeholder": "Nhập tên hiển thị cho trường"
			},
			"type_field": {
				"label": "Loại trường",
				"placeholder": "Chọn loại trường"
			},
			"industry_field": {
				"label": "Ngành",
				"placeholder": "Chọn ngành"
			},
			"address_field": {
				"label": "Địa chỉ",
				"placeholder": "Chọn địa chỉ của trường"
			},
			"phone_field": {
				"label": "Số điện thoại",
				"placeholder": "+1-000-000-0000",
				"code": "Mã"
			},
			"country_field": {
				"label": "Quốc gia",
				"placeholder": "Nhập quốc gia"
			},
			"state_field": {
				"label": "Bang/huyện",
				"placeholder": "Nhập bang/huyện"
			},
			"city_field": {
				"label": "Thành phố",
				"placeholder": "Nhập thành phố"
			},
			"post_code_field": {
				"label": "Mã bưu điện",
				"placeholder": "0000-00"
			}
		}
	},
	"company": {
		"setup_company": {
			"successfully_created": "Công ty của bạn đã được tạo thành công.",
			"setup_your_company": "Cài đặt công ty của bạn",
			"invite_students_teachers": "Mời học sinh và giáo viên tham gia công ty của bạn.",
			"create_class": "Tạo lớp",
			"invite_teachers": "Mời giáo viên",
			"invite_students": "Mời học sinh",
			"continue": "Tiếp tục"
		},
		"create_edit_modal": {
			"title": "Tạo công ty",
			"create": "Tạo",
			"cancel": "Huỷ bỏ",
			"name_field": {
				"label": "Tên công ty",
				"placeholder": "Nhập tên công ty"
			},
			"username_field": {
				"label": "Tên đăng nhập công ty",
				"placeholder": "Nhập tên đăng nhập của công ty"
			},
			"type_field": {
				"label": "Loại công ty",
				"placeholder": "Nhập loại công ty"
			},
			"industry_field": {
				"label": "Loại ngành",
				"placeholder": "Nhập ngành nghề"
			},
			"address_field": {
				"label": "Địa chỉ",
				"placeholder": "Nhập địa chỉ của trường"
			},
			"phone_field": {
				"label": "Số điện thoại",
				"placeholder": "+1-000-000-0000",
				"code": "Mã"
			},
			"country_field": {
				"label": "Quốc gia",
				"placeholder": "Nhập quốc gia"
			},
			"state_field": {
				"label": "Bang/huyện",
				"placeholder": "Nhập bang/huyện"
			},
			"city_field": {
				"label": "Thành phố",
				"placeholder": "Nhập thành phố"
			},
			"post_code_field": {
				"label": "Mã bưu điện",
				"placeholder": "0000-00"
			}
		}
	},
	"teacher": {
		"are_you_part_of_organization": "Bạn có phải là thành viên của một tổ chức không?",
		"select_one_options": "Chọn một trong các lựa chọn dưới đây",
		"yes": "Có",
		"no": "Không",
		"teach_myself": "Tôi tự dạy cho mình",
		"continue": "Tiếp tục",
		"do_you_have_invitation_code": "Bạn có mã lời mời không?"
	},
	"student": {
		"are_you_part_of_organization": "Bạn có phải là thành viên của một tổ chức không?",
		"select_one_options": "Chọn một trong các lựa chọn dưới đây",
		"yes": "Có",
		"no": "Không",
		"learning_myself": "Tôi tự học",
		"continue": "Tiếp tục",
		"do_you_have_invitation_code": "Bạn có mã lời mời không?"
	},
	"setup_organization": {
		"join_your_organization": "Tham gia tổ chức của bạn",
		"wait_for_admin": "Vui lòng đợi quản trị viên gửi lời mời cho bạn hoặc nhập mã lời mời.",
		"enter_invitation_code": "Nhập mã lời mời",
		"continue": "tiếp tục",
		"welcome_to_organization": "Chào mừng bạn đến tổ chức A",
		"you_can_create_own_class": "Bạn có thể tạo lớp của riêng bạn hoặc đợi quản trị viên chỉ định bạn vào một lớp nào đó",
		"create_class": "Tạo lớp"
	},
	"start_learning": {
		"start_learning": "Bắt đầu học",
		"download_elsa_app": "Vui lòng tải ứng dụng ELSA Speak trên thiết bị di động của bạn:",
		"or_send_the_email_by_link_sms": "Hoặc nhận link tải xuống qua email hoặc tin nhắn SMS:",
		"send_email_link": "gửi link cho tôi qua email",
		"send_sms_link": "gửi link cho tôi qua tin nhắn",
		"start_practice": "Bắt đầu thực hành",
		"you_can_download": "Bạn có thể tải xuống ứng dụng và bắt đầu thực hành:",
		"to_join_our_organization": "Để tham gia tổ chức của bạn, vui lòng đợi quản trị viên mời bạn hoặc nhập mã lời mời",
		"enter_invitation_code": "Nhập mã lời mời",
		"email_link_sent": "Link đã được gửi vào email",
		"sms_link_sent": "Link đã được gửi vào tin nhắn",
		"get_email_link_modal": {
			"title": "Nhận link qua email",
			"get_email_link": "Nhận link qua email",
			"email_field": {
				"label": "Email",
				"placeholder": "Nhập địa chỉ email"
			},
			"phone_type_field": {
				"label": "Loại điện thoại",
				"placeholder": "Loại điện thoại"
			},
			"success": "Email đã được gửi",
			"warning": "Email không thể gửi đi, vui lòng thử lại sau"
		},
		"send_sms_link_modal": {
			"title": "Nhận link qua tin nhắn",
			"get_sms_link": "Nhận link qua tin nhắn",
			"phone_type_field": {
				"label": "Loại điện thoại",
				"placeholder": "Loại điện thoại"
			},
			"phone_field": {
				"label": "Số điện thoại",
				"placeholder": "+1-000-000-0000",
				"code": "Mã"
			},
			"success": "Tin nhắn đã được gửi",
			"warning": "Tin nhắn không thể gửi đi, vui lòng thử lại sau"
		}
	},
	"industries": {
		"aerospace": "Hàng không vũ trụ",
		"transportation": "Giao thông vận tải",
		"computer_software_internet": "Máy tính, Phần mềm, & Internet",
		"telecommunication": "Viễn thông",
		"food_and_agriculture": "Lương thực và Nông nghiệp",
		"construction": "Xây dựng",
		"education": "Giáo dục",
		"healthcare": "Y tế",
		"travel_and_hospitality": "Du lịch & Khách sạn",
		"entertainment_news_media_music": "Giải trí, Tin tức & Truyền thông",
		"energy": "Năng lượng",
		"manufacturing": "Công nghiệp chế tạo",
		"fashion_and_clothing": "Thời trang & May mặc",
		"mining": "Khai thác mỏ",
		"consulting_services": "Tư vấn/Dịch vụ",
		"other": "Khác"
	},
	"classes": {
		"accepted_users": "Người dùng được chấp nhận",
		"pending_users": "Người dùng đang chờ xử lý",
		"success_class_updated": "Lớp học được cập nhật thành công",
		"success_remove_user":"Xóa người dùng khỏi lớp học thành công",
		"reports": "Báo cáo",
		"filter_menu": {
			"all": "Tất cả",
			"active": "đang hoạt động",
			"not_started": "Chưa bắt đầu",
			"draft": "Bản nháp",
			"finished": "Đã kết thúc"
		},
		"table_titles": {
			"start_date": "Ngày bắt đầu",
			"end_date": "Ngày kết thúc",
			"status": "Tình trạng"
		},
		"classes_details": {
			"left": "còn lại",
			"to_go": "to go",
			"edit_class_name": "Chỉnh sửa {name}",
			"menu": {
				"overview": "Tổng quan",
				"detailed_progress": "Tiến trình chi tiết",
				"time_tracking": "Theo dõi thời gian"
			},
			"overview_section": {
				"title": "Tổng quan",
				"students": "Học viên",
				"view_list": "Xem thêm",
				"goals": "Mục tiêu",
				"no_goals_set": "Chưa có mục tiêu nào được thiết lập cho lớp học này.",
				"minutes_per_day": "phút mỗi ngày",
				"days_practice_per_week": "ngày học mỗi tuần",
				"set_goals": "Thiết lập mục tiêu",
				"assessment_test_results": "Kết quả kiểm tra đánh giá",
				"average_score": "Điểm trung bình",
				"test_before_class_stats": "ngày để làm kiểm tra đánh giá"
			},
			"students_section": {
				"title": "Học sinh",
				"pro_licence": "Pro License",
				"assessment_test": "Điểm kiểm tra đánh giá",
				"date_take_assessment": "Ngày kiểm tra",
				"last_active_practice": "Thời gian học cuối",
				"practice_days_week": "Số ngày học / tuần",
				"min_spent": "Số phút học",
				"last_eps": "Điểm EPS cuối",
				"avg_daily_use": "Trung bình học (phút/ngày)",
				"copy_paste_emails": "Sao chép và dán địa chỉ email",
				"module_name": "Tên Học phần",
				"lesson_name": "Tên Bài học",
				"lesson_EPS": "bài học EPS",
				"lesson_take_date": "Ngày học",
				"difficulty_level": "Mức độ khó"
			},
			"activity_reports": {
				"title": "Báo cáo hoạt động",
				"lessons_overview": "Tổng quan bài học",
				"number_of_lessons_practiced": "Số bài học và số phút học",
				"average_practice": "Thời gian học trung bình mỗi ngày (phút)",
				"progress": "Biểu đồ tiến độ (EPS trung bình)",
				"progress_student": "Biểu đồ tiến độ (EPS)",
				"0_5_percent": "0% - 5%",
				"6_10_percent": "6% - 10%",
				"11_50_percent": "11% - 50%",
				"51_70_percent": "51% - 70%",
				"mt_70_percent": "Hơn 70%"
			}
		},
		"create_class_flow": {
			"save_finish_later": "Lưu và hoàn thành sau",
			"cancel": "Huỷ bỏ",
			"save": "Lưu",
			"next": "Tiếp theo",
			"previous": "Quay lại",
			"details": "Chi tiết",
			"list_students_modal": {
				"got_it": "Đã xong!",
				"warning_no_student": "Không học viên nào được mời"
			},
			"class_details": {
				"start_end_date": "Ngày bắt đầu và ngày kết thúc"
			},
			"add_students": {
				"copy_paste_emails": "Sao chép và dán địa chỉ email",
				"insert_multiple_emails": "Nhập nhiều emails (cách nhau bởi các dấu phẩy)"
			},
			"class_overview": {
				"details": "Chi tiết",
				"start_end_date": "Ngày bắt đầu và ngày kết thúc",
				"not_selected": "Không được chọn",
				"create_and_send_invites": "Tạo và gửi lời mời"
			},
			"class_created": {
				"goals_section": {
					"practice_at_least": "Thực hành tối thiểu",
					"days_week": "ngày một tuần.",
					"keep_them_engaged": "Yêu cầu học viên tham gia hằng tuần",
					"practice": "Thực hành",
					"minutes_day": "phút mỗi ngày.",
					"studies_review": "Các nghiên cứu cho thấy thực hành ít nhất 10 phút mỗi ngày đem lại kết quả tốt nhất khi học một ngôn ngữ mới.",
					"take_assessment_test": "Làm bài Kiểm tra đánh giá trong vòng",
					"days_before_invitations": "ngày sau khi được mời.",
					"next": "Tiếp theo",
					"will_do_this_later": "Tôi sẽ làm sau."
				}
			}
		}
	},
	"dashboard": {
		"reports_overview": "Tổng quan báo cáo",
		"notifications": "Thông báo",
		"overview": "Tổng quan",
		"manage": "Quản lý",
		"licenses": "Licenses",
		"users": "Người dùng",
		"request_license": "Yêu cầu License",
		"student": {
			"view_class": "xem lớp",
			"view_all_classes": "xem tất cả lớp",
			"goals": {
				"minutes_per_day": "Mục tiêu học { minutes } phút mỗi ngày",
				"minutes_per_day_value": "Trung bình bạn học { minutes } phút mỗi ngày",
				"days_per_week": "Mục tiêu học {days} ngày mỗi tuần",
				"days_per_week_value": "Trung bình bạn học {days} ngày mỗi tuần",
				"level": "Mức độ {level}",
				"level_value": "Trung bình {level}%"
			},
			"minutes_spend_per_day": "Phút là thời gian trung bình dành cho mỗi ngày"
		}
	},
	"charts": {
		"active_users": "Người dùng có hoạt động",
		"avg_practice_time": "Thời gian học trung bình",
		"avg_eps": "EPS",
		"number_of_lessons": "Số bài học",
		"number_of_seconds": "Thời gian học",
		"user_eps_score": "EPS",
		"not_active": "Không hoạt động",
		"1_4_days": "1-4 ngày một tuần",
		"5_5_days": "5 ngày một tuần",
		"6_7_days": "6-7 ngày một tuần",
		"percentage": "%"
	}
}
